import axios from '@/axios'

// Education systems

export async function listEducationSystems () {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/education-systems')
  return response.data.data
}

export async function newEducationSystem (data) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/education-systems/', data)
  return response.data.data
}

export async function getEducationSystem (id) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/education-systems/' + id)
  return response.data.data
}

export async function updateEducationSystem (id, data) {
  const response = await axios.put(import.meta.env.VITE_API_URL + '/v2/intranet/education-systems/' + id, data)
  return response.data.data
}

export async function deleteEducationSystem (id) {
  const response = await axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/education-systems/' + id)
  return response.data.data
}

export default {
  listEducationSystems,
  newEducationSystem,
  getEducationSystem,
  updateEducationSystem,
  deleteEducationSystem
}
